// Created by hejikun on 2017/11/2 0002.
let aiChat = [
    {
      path: '/ai_chat/chat',
      name: 'AI聊天',
      component: () => import('@/pages/AIChat/chat')
    },
    {
      path: '/voice_guide',
      name: '语音挂号',
      component: () => import('@/pages/AIChat/voice_guide.vue')
    },
    {
      path: '/ai_guidance',
      name: '智能导诊',
      component: () => import('@/pages/AIChat/guidance.vue')
    }
  ]

  export default aiChat
